"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFormProps = void 0;
const types_1 = require("../../types");
const command_manager_1 = require("../../command_manager");
const form_1 = require("../../model/form");
const store_1 = require("../../exports/store");
exports.updateFormProps = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { formId, partialProps } = options;
        const snapshot = store_1.Selectors.getFormSnapshot(state, formId);
        if (!snapshot) {
            return null;
        }
        const updateFormPropsAction = form_1.FormAction.updatePropsAction(snapshot.formProps, { partialProps });
        if (updateFormPropsAction.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: formId,
            resourceType: types_1.ResourceType.Form,
            actions: updateFormPropsAction,
        };
    },
};
//# sourceMappingURL=index.js.map